export const checkVersion = (i18n = {}, ukLink, anotherLink) => i18n.language === 'uk' ? ukLink : anotherLink